import React, { useState } from "react";
import { Modal, Box, Typography, Button, IconButton } from "@material-ui/core";

import rest from "../../../rest";
import CloseIcon from "@material-ui/icons/Close";
import { MySnackbar } from "../../../components/mySnackbar/MySnackbar";
import useStyles from "../../../pages/attribution/modal/ModalStyle";

const EditionModele = ({
  open,
  handleClose,
  setRefresh,
  modelId,
  modelName,
  setSelectedModelID,
}) => {
  const [snack, setSnack] = useState({});
  const classes = useStyles()();

  const handleDelete = () => {
    rest
      .post("/benevols/removeModel.json", {
        idModel: modelId,
      })
      .then((response) => {
        if (!response.data.error) {
          setRefresh((prev) => !prev);
          setSelectedModelID(0);
          handleClose();
        }

        setSnack({
          message: response.data.message,
          show: true,
          severity: response.data.error ? "error" : "success",
        });
      })
      .catch((error) => {
        console.error(
          "Une erreur s'est produite lors de la suppression du nouveau modèle :",
          error
        );
      });
  };

  return (
    <>
      <MySnackbar params={snack} />
      <Modal
        open={open}
        onClose={handleClose}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className={classes.paper}>
          <div className={classes.header}>
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography variant="h6" className={classes.title}>
                Voulez vous supprimer le modèle {modelName} ?
              </Typography>
              <IconButton onClick={handleClose} className={classes.closeButton}>
                <CloseIcon />
              </IconButton>
            </Box>
          </div>
          <div className={classes.content}>
            <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end" }}>
              <Button onClick={handleClose} sx={{ mr: 1 }}>
                Annuler
              </Button>
              <Button
                onClick={handleDelete}
                color="primary"
                variant="contained"
              >
                Supprimer
              </Button>
            </Box>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default EditionModele;
